import { combineReducers } from 'redux';

import basicState, { basicInitialState } from './basic';
import inspectorState, { inspectorInitialState } from './inspector';

export const tasksInitialState = { 
  basicState: basicInitialState,
  inspectorState: inspectorInitialState,
}

export default combineReducers({ 
  basicState,
  inspectorState
})